import { useParams } from 'react-router-dom';
import CacheReviewPage from '@/pages/CacheReviewPage';

export default function TeamInteractionsTab() {
  const { teamId } = useParams<{ teamId: string }>();
  if (!teamId) return null;
  return <CacheReviewPage embeddedTeamId={teamId} />;
}
